import React from 'react';

import Avatar from '../user/avatar';
import Summary from '../user/summary';
import Togglable from '../togglable';

import { formatTimestamp, formatDate, formatFileSize } from "../../util";

const MetaLine = Togglable(({ label, children }) => (
	<tr>
		<td className="pl-3 pr-0 text-black-secondary text-nowrap">{label}:</td>
		<td className="px-3 w-100">{children}</td>
	</tr>
))

const MiscMetadata = ({ owner, datetimeCreated, datetimeLastModified, duration, size, views, copyright }) => (
	<div className="card mb-3 mb-lg-4">
		<div className="card-body">
			<Summary user={owner} />
		</div>
		<table className="table border-top mb-0">
			<tbody>
				<MetaLine label="Created">{formatDate(datetimeCreated)}</MetaLine>
				<MetaLine label="Updated">{formatDate(datetimeLastModified)}</MetaLine>
				<MetaLine visible={duration !== null} label="Length">{formatTimestamp(duration)}</MetaLine>
				<MetaLine visible={size !== null} label="Size">{formatFileSize(size)}</MetaLine>
				<MetaLine visible={views !== null} label="Views">{views}</MetaLine>
				<MetaLine visible={copyright !== null} label="Copyright">{copyright}</MetaLine>
			</tbody>
		</table>
	</div>
)

export default MiscMetadata;